import { QueryError } from '@graphql-box/helpers';

import { useQuery } from '@graphql-box/react';
import { ScreenType } from '@tmdb-graphql-api/schema/types';
import { useEffect } from 'react';
import { Component } from './Component.tsx';
import { type MovieReviewsData, type TvReviewsData, getReviewsTotal } from './helpers/getReviewsTotal.ts';
import { type QueryProps } from './types.ts';

const queries = {
  [ScreenType.Movie]: "\nquery GetMovieReviewsTotal(\n  $id: ID!\n) {\n  movie(id: $id) {\n    ...MovieReviewsTotal\n  }\n}\n\nfragment MovieReviewsTotal on Movie {\n  reviews(first: 1) {\n    totalCount\n  }\n}\n",
  [ScreenType.Tv]: "\nquery GetTvReviewsTotal(\n  $id: ID!\n) {\n  tv(id: $id) {\n    ...TvReviewsTotal\n  }\n}\n\nfragment TvReviewsTotal on Tv {\n  reviews(first: 1) {\n    totalCount\n  }\n}\n",
};

export const Query = ({ children, compact, id, sx, title, type }: QueryProps) => {
  const query = queries[type];

  const { execute, result } = useQuery<MovieReviewsData | TvReviewsData>(query, {
    loading: true,
  });

  useEffect(() => {
    void execute({ variables: { id } }, { data: { initiator: 'ReviewBadge' } });
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (result instanceof QueryError) {
    console.error(result);
    return;
  }

  if (result?.errors?.length) {
    console.error(result.errors);
  }

  const reviews = getReviewsTotal(result?.data);
  const output = <Component compact={compact} id={id} reviews={reviews} sx={sx} title={title} type={type} />;
  return children ? children(output) : output;
};
